import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 * @param state - the application state
 * @returns rosters - the rosters reducer
 */
export const selectRostersReducer = (state: AppState) => state.businessRosters

/**
 * Gets the rosters' data from the rosters reducer
 */
export const selectBusinessRosters = createSelector(
  selectRostersReducer,
  (rostersState) => rostersState.data
)

/**
 * Gets the rosters' isFetching from the rosters reducer
 */
export const selectBusinessRostersIsFetching = createSelector(
  selectRostersReducer,
  (rostersState) => rostersState.isFetching
)

/**
 * Gets the rosters' meta from the rosters reducer
 */
export const selectBusinessRostersMeta = createSelector(
  selectRostersReducer,
  (rostersState) => rostersState.meta
)
